import { uniqBy } from "@s-libs/micro-dash";

const formatUpdatedActivities = (assignmentActivities, updatePayload) => {
  const { action, attachmentIds } = updatePayload;

  if (action === "remove") {
    return assignmentActivities.filter((activity) => {
      return !attachmentIds.includes(activity.content_id);
    });
  }

  const attachmentIdsToAdd =
    attachmentIds?.map((attachmentId) => ({ content_id: attachmentId })) || [];

  return uniqBy(
    [...assignmentActivities, ...attachmentIdsToAdd],
    (activity) => activity.content_id,
  );
};

export default formatUpdatedActivities;
